import * as React from "react";
export var renderLeague = function (showLeagueInEventCard, leagueName, componentPrefix) {
    return showLeagueInEventCard &&
        React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__league", "data-uat": "div-ev-list-" + componentPrefix + "-league" },
            React.createElement("span", { className: "rj-ev-list__name-text", "data-uat": "span-ev-list-name-text" }, leagueName));
};
//# sourceMappingURL=renderLeague.js.map